// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2WsyN","calendarButtons":"ClockData_calendarButtons__2wN0C"};